<template>
  <q-page class="q-px-md">
    <h1 class="text-h5">Clients</h1>
    <div class="bg-white shadow-1">
      <clients-table :customer-id="accountId" flat ref="clients" />
    </div>
  </q-page>
</template>

<script>
import ClientsTable from '../client/ClientsTable.vue';

export default {
  meta: {
    title: 'Clients',
  },
  components: {
    ClientsTable,
  },
  props: {
    accountId: {
      type: Number,
      required: true,
    },
  },
};
</script>
